module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAABBCAYAAABfEM01AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAATVJREFUeNrM120KwjAMBuD54pn87WW8h0fbxQRRNilla/PxJjFQStsUni3Zj11uj9dzWZZ1GyWBbb5voxRRCkFXhhIIDvohHbKXoxTS9kQZBN26BIKDvXQITvZTIRicpUEwOU+BQJATDoEwLxQCRW4YBMr8EAgMd+gQGO9RIXA8AA0CZzkpEBCa2w0B6VN3QVgIF4SJMEPYCBMkAqGGRCFUkEiEGBKNEEEyEFNIFmIIuSb/dq4N4Ddj+YPIRvRN+S0RqgGZb+IUkIUYAjIQU0A0QgSIRIgBUQgVIAKhBrARJgATYQawEC4AA+EGeBEUgAdBA1gRVIAFQQdoESEADSIMIEWEAiSIcMAMkQIYIdIAZ4hUwBEiHdAjSgAtogywI0oBLaIM0PdECaBFlAF2RCngE28BBgBUBnvcHpnFpAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/features_jiantou_right.png
// module id = rTrd
// module chunks = 1